export default __webpack_public_path__ + "static/media/login1.42fa1b27.png";